export default {
  studyPlan: 'Study Plan',
  studyPlanSummary: 'Study Plan Summary',
  showHoursBy: 'Show hours by',
  week: 'Week',
  weeks: 'Weeks',
  total: 'Total',
  suggestedTotal: 'Suggested Total',
  initialLevel: 'Initial Level',
  finalLevel: 'Final Level',
  totalPedagogicalHours: 'Total pedagogical hours',
  asteriskLegend: 'The \' * \' represents that this value will not be counted in the Total Hours calculation.',
  number: 'No.',
  requirements: 'Requirements',
  prerequisites: 'prerequisites',
  totalCredits: 'Total Credits',
  suggestedMaximum: 'Suggested maximum',
  totalOfCredits: 'Total of Credits',
  suggestedMaximumCredits: 'Suggested maximum credits',
  maximumModulesSuggested: 'Suggested maximum modules',
  commentsOf: 'Comments of',
  enterCommentPlaceholder: 'Enter your comment here...',
  level: 'Level',
  semester: 'Semester',
  quarter: 'Quarter',
  bimonthly: 'Bimonthly',
  notApplicable: 'N/A',
  notApply: 'Not Apply',
  inTheArea: 'in the Area',
  totalOfCreditsInTheArea: 'Total of Credits in the Area',
  without: 'Without',
  valuesMustBeBetween1To100: 'Values must be between 1 ~ 100',
  valuesMustBeBetween1To52: 'Values must be between 1 ~ 52',
  twoOrMore: 'Two or more',
  haveTheSameNumber: 'have the same number',
  selectPrerequisites: 'Select Prerequisites',
  doNotSelect: '-- Do not select --',
  toMarkOneOrMore: 'To mark one or more',
  removeFromYourSelection: 'remove from your selection (-- Do not select --)',
  theseHoursDoNotCountTowardsTotal: 'These hours do not count towards the total',
  automaticCredits: 'Automatic Credits',
  plannedCredits: 'Planned Credits',
  copyAutomaticCreditInfo: 'Copy automatic credit information',
  changingHoursWillChangeCreditsAutomatically: 'Changing hours will automatically change credits',
  thePrerequisitesPlural: 'The prerequisites',
  thePrerequisiteSingular: 'The prerequisite',
  areLinkedPlural: 'are linked',
  isLinkedSingular: 'is linked',
  areYouSureYouWantTo: 'Are you sure you want to',
  unlinkThemPlural: 'unlink them',
  unlinkItSingular: 'unlink it',
  forThisEgressProfile: 'for this Egress Profile?',
  information: 'Information',
  confirm: 'Confirm',
  atTransversalSubjectLevel: 'at Transversal Subject level',
  changeMade: 'Change made',
  automatic: 'Automatic',
  chronologicalHours: 'Chronological Hours',
  copyAutomaticHour: 'Copy Automatic Hour',
  copyInformation: 'Copy the information from the {entity} automatically',
  downloadRectorateDecree: 'Rectorate Decree (Word)',
  generatingWord: 'Generating Word...'
}
